export const API_URL = process.env.REACT_APP_API_URL;
export const ELIPAY_LOCAL_STORAGE = 'Elipay/POS';
export const PAYMENT_DURATION = 300;
export const IS_GOCRYPTO = process.env.REACT_APP_IGNORES_SUBPATH;
export const ROUTE_PREFIX = process.env.REACT_APP_IGNORES_SUBPATH === 'false' ? '/pos' : '';
export const revertAccounts = ["predstavitev@elipay.com", "info@elipay.com", "online@elipay.com"];
export const MAX_EURO_PAYMENT = 15000.0;
export const MIN_EURO_PAYMENT = 0.01;
